class StringOrNullOrUndefinedClass {
  value: unknown;

  constructor(value?: unknown) {
    this.value = value;
  }

  static from<T>(value?: T): string | undefined {
    return value === undefined
      ? undefined
      : value === null
      ? undefined
      : String(value);
  }
}

// Declarar la interfaz y el constructor
interface StringOrNullOrUndefinedConstructor {
  new (value?: unknown): StringOrNullOrUndefinedClass;
  (value?: unknown): string | undefined;
  readonly prototype: StringOrNullOrUndefinedClass;
}

const StringOrNullOrUndefinedFunction = function (this: unknown, value?: unknown) {
  if (this instanceof StringOrNullOrUndefinedFunction) {
    return new StringOrNullOrUndefinedClass(value);
  } else {
    return StringOrNullOrUndefinedClass.from(value);
  }
};

StringOrNullOrUndefinedFunction.prototype =
  StringOrNullOrUndefinedClass.prototype;
export const StringOrNullOrUndefined: StringOrNullOrUndefinedConstructor =
  StringOrNullOrUndefinedFunction as StringOrNullOrUndefinedConstructor;

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}
